import type { ReactNode } from "react";

export type StatusTone =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "danger";

/**
 * Single status-pill recipe used across the app — shipment status,
 * payment status, invoice status, voucher state.
 *
 * Same shape (rounded-full, px-2.5 py-1, text-xs font-medium) and the
 * same explicit Tailwind bg-{tone}-100 + text-{tone}-700 pair on every
 * caller so colors line up regardless of which heroui Chip variant
 * decides to render faintly.
 */
const toneClasses: Record<StatusTone, string> = {
  default: "bg-default-100 text-default-700",
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-700",
  success: "bg-success-100 text-success-700",
  warning: "bg-warning-100 text-warning-700",
  danger: "bg-danger-100 text-danger-700",
};

interface StatusBadgeProps {
  tone: StatusTone;
  children: ReactNode;
  className?: string;
}

export function StatusBadge({ tone, children, className }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
        toneClasses[tone]
      } ${className ?? ""}`}
    >
      {children}
    </span>
  );
}
